import React, { useState } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  Modal,
  StyleSheet,
} from "react-native";
import { useSelector, useDispatch } from "react-redux";
import { Picker } from "@react-native-picker/picker";
import { Ionicons } from "@expo/vector-icons";
import { updateIncident, fullDataPiece } from "../../services/ConnectDataBase";
import { SCREEN_IDS } from "../FullComponent";
import { typeConnect } from "../../constants/Constants";
import { updateIncidents } from "../../redux/reducers";
import { getArrayInfoDataUpdate } from "../../services/Functions";
import { STATUS_COLORS, BORDER_COLORS, SHADOW_COLORS } from "../../style/colors.js";

const CleanIncident = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const infoData = useSelector((state) => state.infoData.infoData);
  const currentScreenId = SCREEN_IDS.TIME_WORK;
  const screenName = "ComponentIncident";
  const filteredTiempos = infoData.tiempos.filter(
    (item) => parseFloat(item.cantidad_incidencia) > 0
  );

  const [formData, setFormData] = useState({
    po: filteredTiempos.length === 1 ? filteredTiempos[0].po : "",
    mo: filteredTiempos.length === 1 ? filteredTiempos[0].mo : "",
    usuario: filteredTiempos.length === 1 ? filteredTiempos[0].usuario : "",
    fecha_ini: filteredTiempos.length === 1 ? filteredTiempos[0].fecha_ini : "",
    cantidad_incidencia: "0",
  });

  const handlePress = () => {
    setModalVisible(true);
  };

  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      const clean = await updateIncident(
        screenName,
        typeConnect[2],
        currentScreenId,
        formData.po,
        formData.mo,
        formData.usuario,
        formData.fecha_ini,
        formData.cantidad_incidencia
      );
    } catch (error) {
      console.error(error);
    }
    setModalVisible(false);
    const newInfo = await fullDataPiece(formData.mo, 2);
    const infoData = getArrayInfoDataUpdate(newInfo);
    dispatch(updateInfoData(infoData));
  };

  return (
    <View>
      <TouchableOpacity style={styles.button} onPress={handlePress}>
        <Text style={styles.buttonText}>Quitar incidencia</Text>
      </TouchableOpacity>

      <Modal
        visible={modalVisible}
        animationType='slide'
        transparent={true}
        onRequestClose={() => setModalVisible(false)}>
        <View style={styles.modalOverlay}>
          <View style={styles.modalContent}>
            <TouchableOpacity
              style={styles.closeButton}
              onPress={() => setModalVisible(false)}>
              <Ionicons name='close' size={24} color='black' />
            </TouchableOpacity>
            <Text style={styles.modalTitle}>Quitar Incidencia</Text>
            <TextInput
              style={styles.input}
              placeholder='PO'
              value={formData.po}
              editable={false}
            />
            <TextInput
              style={styles.input}
              placeholder='MO'
              value={formData.mo}
              editable={false}
            />
            {filteredTiempos.length > 1 ? (
              <Picker
                selectedValue={formData.usuario}
                style={styles.input}
                onValueChange={(value) => handleChange("usuario", value)}>
                <Picker.Item label='...' value='' />
                {filteredTiempos.map((item, index) => (
                  <Picker.Item
                    key={index}
                    label={item.usuario}
                    value={item.usuario}
                  />
                ))}
              </Picker>
            ) : (
              <TextInput
                style={styles.input}
                placeholder='Usuario'
                value={formData.usuario}
                editable={false}
              />
            )}
            {filteredTiempos.length > 1 ? (
              <Picker
                selectedValue={formData.fecha_ini}
                style={styles.input}
                onValueChange={(value) => handleChange("fecha_ini", value)}>
                <Picker.Item label='...' value='' />
                {filteredTiempos.map((item, index) => (
                  <Picker.Item
                    key={index}
                    label={item.fecha_ini}
                    value={item.fecha_ini}
                  />
                ))}
              </Picker>
            ) : (
              <TextInput
                style={styles.input}
                placeholder='Fecha Inicio'
                value={formData.fecha_ini}
                editable={false}
              />
            )}
            <TextInput
              style={styles.input}
              placeholder='Cantidad Incidencia'
              value={formData.cantidad_incidencia}
              onChangeText={(value) =>
                handleChange("cantidad_incidencia", value)
              }
            />
            <TouchableOpacity
              style={styles.submitButton}
              onPress={handleSubmit}>
              <Text style={styles.submitButtonText}>Enviar</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    // marginLeft: "50%",
  },
  button: {
    backgroundColor: STATUS_COLORS.ERROR_LIGHT,
    fontFamily: "monospace",
    fontSize: 16,
    fontWeight: "bold",
    alignContent: "center",
    alignItems: "center",
    alignSelf: "center",
    marginTop: -10,
    textAlign: "center",
    borderColor: "#00796B",
    borderRadius: 5,
    padding: 8,
    marginBottom: 5,
    width: "50%",
  },

  buttonText: {
    color: "white",
    fontSize: 16,
    fontWeight: "bold",
  },
  modalOverlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalContent: {
    width: 300,
    padding: 20,
    backgroundColor: "white",
    borderRadius: 10,
    alignItems: "center",
    elevation: 3,
    shadowColor: SHADOW_COLORS.PRIMARY,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 2,
  },
  closeButton: {
    position: "absolute",
    top: 10,
    right: 10,
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 10,
  },
  input: {
    width: "100%",
    padding: 10,
    borderWidth: 1,
    borderColor: BORDER_COLORS.MEDIUM,
    borderRadius: 5,
    marginBottom: 10,
  },
  submitButton: {
    backgroundColor: STATUS_COLORS.SUCCESS,
    padding: 10,
    borderRadius: 5,
    marginTop: 10,
    elevation: 3,
    shadowColor: SHADOW_COLORS.PRIMARY,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 2,
  },
  submitButtonText: {
    color: "white",
    fontSize: 16,
    fontWeight: "bold",
  },
});

export default CleanIncident;
